// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import legalCaseHearingEntity from './entities/legal-case-hearing.json';
import legalCaseHearingMenu from '../pages/legal-case-hearing/menu.json';
import legalCaseHearingFullForm from '../pages/legal-case-hearing/forms/full.json';
import legalCaseHearingContextForm from '../pages/legal-case-hearing/forms/context.json';
import legalCaseHearingMiniForm from '../pages/legal-case-hearing/forms/mini.json';
import legalCaseHearingLookupForm from '../pages/legal-case-hearing/forms/lookup.json';
import legalCaseHearingTableView from '../pages/legal-case-hearing/views/table.json';
import legalCaseHearingCardsView from '../pages/legal-case-hearing/views/cards.json';
import legalCaseHearingDashboardView from '../pages/legal-case-hearing/views/dashboard.json';

/** Тип запису «Судове засідання» зі сторінками пакета: меню, форми та подання з pages/legal-case-hearing/. */
export const legalCaseHearingDefinition: IRecordTypeDefinition = {
  ...legalCaseHearingEntity,
  views: assembleViewSet({
      table: legalCaseHearingTableView,
      cards: legalCaseHearingCardsView,
      dashboard: legalCaseHearingDashboardView,
  }),
  form: legalCaseHearingFullForm,
  forms: { full: legalCaseHearingFullForm, context: legalCaseHearingContextForm, mini: legalCaseHearingMiniForm, lookup: legalCaseHearingLookupForm },
  menu: legalCaseHearingMenu,
} as IRecordTypeDefinition;
